module.exports = __webpack_public_path__ + "static/media/ic-phone.41f9d173.svg";